import {
    CLASE_CHANGED,
    CLASE_CLEAR,
} from './actions'


let initialState = {
    clases: [],
}

export const cache = (state = initialState, action) => {
    switch (action.type) {
        case CLASE_CHANGED:
            return cacheChangeClase(state, action.clase);
        case CLASE_CLEAR:
            return cacheClearClase(state, action.clase);
        default:
            return state;
    }
}

const cacheChangeClase = (state, clase) => {
    state.clases[clase.nombreClase]= clase.datos;
    //let newState= { ...state, clases: [...state.clases] };
    let newState= {...state};
    return newState;
}

const cacheClearClase = (state, clase) => {
    console.log("CLEAR CACHE");
    if (clase.nombreClase && clase.nombreClase !== ""){
        delete  state.clases[clase.nombreClase];
    }
    else{
        state.clases= [];
    }
    let newState= {...state};
    console.log(newState);
    return newState;
}


